module.exports = __webpack_public_path__ + "img/pg5_resources.65fb6d15.png";